import { normalizeFilters } from '@user/components/Filters'
import { FunnelFilterType, SalesFunnelFilterSet } from './typings'
import { localDate } from '@sales-center/common'

const daysInterval = 30
const toCreatedDate = new Date()
const fromCreatedDate = new Date()

fromCreatedDate.setDate(toCreatedDate.getDate() - daysInterval)

export const defaultFilters: SalesFunnelFilterSet = normalizeFilters<
  FunnelFilterType,
  SalesFunnelFilterSet
>({
  appliedCount: 0,
  normalizedFilters: [],
  orderBy: '',
  filters: {
    createdDate: {
      propertyName: 'createdDate',
      type: 'dateRange',
      value: { matchType: 'bt', start: fromCreatedDate, end: toCreatedDate },
    },
    salesTeamIds: {
      propertyName: 'salesTeamIds',
      type: 'multiSelect',
      propertyIsString: false,
      propertyIsArray: false,
      value: { mode: 'any', options: [] },
    },
    ownerIds: {
      propertyName: 'ownerIds',
      type: 'multiSelect',
      propertyIsString: false,
      propertyIsArray: false,
      value: { mode: 'any', options: [] },
    },
    salesFunnelIds: {
      propertyName: 'salesFunnelIds',
      type: 'multiSelect',
      propertyIsString: false,
      propertyIsArray: false,
      value: { mode: 'any', options: [] },
    },
    type: {
      propertyName: 'type',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: false,
      value: { mode: 'any', options: [] },
    },
  },
  inputModel: {
    salesTeamIds: [],
    ownerIds: [],
    salesFunnelIds: [],
    type: [],
    fromCreatedDate: localDate(fromCreatedDate),
    toCreatedDate: localDate(toCreatedDate),
  },
})

export const defaultClearedFilters: SalesFunnelFilterSet = normalizeFilters<
  FunnelFilterType,
  SalesFunnelFilterSet
>({
  ...defaultFilters,
  filters: {
    ...defaultFilters.filters,
    createdDate: {
      propertyName: 'createdDate',
      type: 'dateRange',
      value: { matchType: 'bt', start: null, end: null },
    },
  },
})
